import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const AuthCallback = () => {
    const hasProcessed = useRef(false);
    const location = useLocation();
    const navigate = useNavigate();
    const { setUser } = useAuth();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const hash = location.hash || "";
        const sessionId = hash.includes("session_id=") ? hash.split("session_id=")[1].split("&")[0] : "";
        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }
        api.post("/auth/session", { session_id: sessionId })
            .then(({ data }) => {
                setUser(data.user);
                const pending = localStorage.getItem("zf_pending_checkout") === "1";
                localStorage.removeItem("zf_pending_checkout");
                toast.success(`Bem-vindo, ${(data.user.name || data.user.email).split(" ")[0]}!`);
                navigate(pending ? "/carrinho" : "/perfil", { replace: true });
            })
            .catch(() => {
                toast.error("Não foi possível concluir o login. Tente novamente.");
                navigate("/", { replace: true });
            });
    }, [location.hash, navigate, setUser]);

    return (
        <div className="flex min-h-[70vh] items-center justify-center pt-28" data-testid="auth-callback">
            <p className="animate-pulse font-mono text-xs uppercase tracking-[0.3em] text-forge-yellow">
                Finalizando login...
            </p>
        </div>
    );
};

export default AuthCallback;
